<template>
  <a-modal
    :visible="visible"
    :footer="false"
    :width="350"
    @cancel="$emit('update:visible', false)"
  >
    <template slot="title">
      <div style="text-align: center;">添加用户</div>
    </template>
    <a-form
      :label-col="{ span: 8 }"
      :wrapper-col="{ span: 16 }"
      :form="form"
      @submit="handleSubmit"
    >
      <a-form-item label="姓名">
        <a-select
          v-decorator="[
            'user_id',
            { rules: [{ required: true, message: '请输入姓名' }] }
          ]"
          option-filter-prop="children"
          showSearch
          placeholder="请选择姓名"
          @change="selectUserChange"
        >
          <a-select-option
            v-for="item in userList"
            :key="item.user_id"
            :value="item.user_id"
          >
            {{ item.name }}
          </a-select-option>
        </a-select>
      </a-form-item>
      <a-form-item label="姓名" v-show="false">
        <a-input placeholder="请输入姓名" v-decorator="['name']" />
      </a-form-item>
      <a-form-item label="用户名拼音">
        <a-input
          placeholder="请输入姓名拼音"
          disabled
          v-decorator="[
            'name_pinyin',
            { rules: [{ required: true, message: '请输入姓名拼音' }] }
          ]"
        />
      </a-form-item>
      <a-form-item label="手机号">
        <a-input placeholder="请输入手机号" v-decorator="['phone']" />
      </a-form-item>
      <div style="text-align: right;">
        <a-button type="primary" html-type="submit">
          添加
        </a-button>
      </div>
    </a-form>
  </a-modal>
</template>

<script>
import { mapState, mapGetters } from "vuex";
import { getUserListFromUUC, addOperationUser } from "@/api/api";
export default {
  data() {
    return {
      form: this.$form.createForm(this),
      userList: []
    };
  },
  props: ["visible"],
  computed: {
    ...mapState(["clientInfo"]),
    ...mapGetters(["defaultInfo"])
  },
  mounted() {
    getUserListFromUUC(this.clientInfo.proId).then(x => {
      this.userList = x.data.data;
    });
  },
  methods: {
    selectUserChange(v) {
      const info = this.userList.find(x => x.user_id == v);
      if (info) {
        const form_ = {
          name: info.name,
          name_pinyin: info.name_pinyin,
          phone: info.phone
        };
        this.form.setFieldsValue(form_);
      }
    },
    handleSubmit(e) {
      e.preventDefault();
      this.form.validateFields(async (errors, values) => {
        if (!errors) {
          let params = [];
          params.push({
            group_id: this.defaultInfo.defaultGroupId,
            user_id: values.user_id,
            name: values.name,
            name_pinyin: values.name_pinyin,
            phone: values.phone
          });
          try {
            let res = await addOperationUser(params);
            this.$message.success(res.data.msg);
            await this.$store.dispatch("getOperationUserList");
            this.$emit("onOk", false);
          } catch (error) {
            console.log(error);
            if (error?.response?.data?.code == 400) {
              this.$message.warning(error.response.data.msg);
            }
          }
        }
      });
    }
  }
};
</script>

<style scoped>
.content-title {
  font-weight: 550;
}
</style>
